import React from 'react';
export function Footer() {
  return <footer className="w-full bg-darker-navy py-8 px-6 border-t border-gray-800" data-id="element-23">
      <div className="max-w-6xl mx-auto text-center" data-id="element-24">
        <p className="text-gray-500 text-sm" data-id="element-25">
          © 2026 Guía de Supervivencia Social y Digital. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}